<template>
    <header class="menu-toggler">
        <div class="logo">
            <span class="menu-collapse" @click="onMenuCollapse()" role="button" aria-label="Menu" tabindex="0">
                <i class="fas fa-bars"></i>
            </span>

            <span class="menu-toggle" @click="onMenuToggle()" role="button" aria-label="Menu" tabindex="0">
                <i class="fas fa-bars"></i>
            </span>
            <h1 @click="onLogoClick()"></h1>
            <!-- <span class="badge-new">Novo</span> -->
        </div>

        <div class="push-right">
            <RouterButton v-if="route.name !== 'compose'"
                class='show-mobile outline'
                icon='fas fa-pencil-alt'
                text="messages.actions.compose"
                link="/compose"
            />
            <LinkButton
                class='clear feedback'
                icon='fas fa-question'
                text="menu.items.help"
                :href="SAPOMailConfig.client.help.url"
                target="_blank"
                tabindex="-1"
            />
        </div>
    </header>

</template>

<script setup>
  import { defineProps }          from 'vue';
  import { useRoute, useRouter }  from 'vue-router';
  import LayoutSettingsController from '@/js/Webmail/LayoutSettingsController.js';
  import LinkButton               from '@/vue/Elements/Buttons/LinkButton.vue'
  import RouterButton             from '@/vue/Elements/Buttons/RouterButton.vue'
  import SAPOMailConfig           from '@/SAPOMailConfig';

  const props = defineProps( {
    webmail_view : {}
  })

  const route = useRoute();
  const router = useRouter();

  const onMenuCollapse = () => {
    LayoutSettingsController.menu_collapsed         = !LayoutSettingsController.menu_collapsed;
    LayoutSettingsController.menu_folders_collapsed = true;
  }

  const onMenuToggle = () => {
    LayoutSettingsController.menu_toggled = !LayoutSettingsController.menu_toggled;
  }

  const onLogoClick = () => {
    router.push( {name: 'home'} )
  }
</script>